import { DestroyRef, inject, Injectable } from '@angular/core';
import { AuthFacade } from '@lentau/auth/store';
import { DeliveryModeFacade } from '@lentau/delivery-mode/store/delivery-mode.facade';
import { MPKeys } from '@lentau/mpk/shared/constants';
import { MpkFacade } from '@lentau/mpk/store';
import { CacheMPKService } from './cache-mpk.service';
import { filter, map, Observable, switchMap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MpkFactoryService } from './mpk.factory';

@Injectable({ providedIn: 'root' })
export class UpdateMpkService {
  private mpkFacade: MpkFacade = inject(MpkFacade);
  private destroyRef: DestroyRef = inject(DestroyRef);
  private authFacade: AuthFacade = inject(AuthFacade);
  private cacheMPKService: CacheMPKService = inject(CacheMPKService);
  private mpkFactoryService: MpkFactoryService = inject(MpkFactoryService);
  private deliveryModeFacade: DeliveryModeFacade = inject(DeliveryModeFacade);

  private setMPK$: Observable<MPKeys> = this.deliveryModeFacade.type$.pipe(
    switchMap(() => this.deliveryModeFacade.isDelivery$),
    map((isDelivery: boolean) => this.mpkFactoryService.getMPKByDelivery(isDelivery))
  );

  public getMPK(): void {
    // логика формирования МПК
    this.authFacade.userAuthorizeType$
      .pipe(
        filter(Boolean),
        switchMap(() => {
          return this.setMPK$;
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((mpk: MPKeys) => {
        this.cacheMPKService.updateCacheMPK(mpk);
        this.mpkFacade.setMPK(mpk);
      });
  }
}
